import Vue from 'vue'
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';

Vue.use(Vuex);

const vuexLocalStorage = new VuexPersist({
    key: 'vuex', // The key to store the state on in the storage provider.
    storage: window.localStorage, // or window.sessionStorage or localForage
});

export const store = new Vuex.Store({
    plugins: [vuexLocalStorage.plugin],
    state: {
        logged: null,
    },
    mutations: {
        setLoggedIn(state, user) {
            state.logged = user;
        },
        setLoggedOut(state) {
            state.logged = null;
        },
    },
    getters: {
        getLogged: (state) => {
            return state.logged
        },
        getUsername: (state) => {
            return state.logged && state.logged.username;
        },
        isAdmin: (state) => {
            return state.logged && parseInt(state.logged.admin);
        },
    }
});
